import Marquee from "react-fast-marquee";

const WORDS = ["EXECUTIVE SEARCH", "HR CONSULTING", "LEADERSHIP", "TALENT ARCHITECTURE", "GLOBAL COMPLIANCE"];

export default function MarqueeStrip() {
  return (
    <section className="border-y border-white/10 bg-[#050B14] py-8" data-testid="marquee-strip">
      <Marquee speed={40} gradient={false}>
        {WORDS.concat(WORDS).map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-5xl md:text-7xl font-extrabold tracking-tight text-stroke px-8">
              {w}
            </span>
            <span className="text-[#00D166] text-4xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
